(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-cricle-section"] && !window.DesignMode) return;
  try {
    
  const swiper = new Swiper('.category-swiper', {
    slidesPerView: 1.5,
    spaceBetween: 30,
    navigation: {
      // Use mobile buttons by default
      nextEl: window.innerWidth <= 768 ? '.swiper-button-next.swiper-mobile' : '.swiper-button-next.swiper-desktop',
      prevEl: window.innerWidth <= 768 ? '.swiper-button-prev.swiper-mobile' : '.swiper-button-prev.swiper-desktop',
    },
    breakpoints: {
      551: {
        slidesPerView: 2.5,
      },
      768: {
        slidesPerView: 2,
      },
      1024: {
        slidesPerView: 2.5,
      },
      1200: {
        slidesPerView: 3.6,
      }
    }
  });

  } catch(e) { console.error(e); }
})();
})();
